module.exports = __webpack_public_path__ + "static/media/card-recipe-finder.c8372275.jpg";